import React from 'react';
import type { LinkProps as ReactRouterLinkProps } from 'react-router-dom';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useGetEffectivePathToNavigate } from '../hooks/useGetEffectivePathToNavigate';

/**
 * Link component which takes user to the a given path. It retains the whitelisted search params from the current path.
 * @param props LinkProps
 */
export const Link = React.forwardRef(
    (props: ReactRouterLinkProps, ref: React.Ref<HTMLAnchorElement>) => {
        const { to, ...rest } = props;
        const getEffectivePathToNavigate = useGetEffectivePathToNavigate();
        return <ReactRouterLink ref={ref} to={getEffectivePathToNavigate(to)} {...rest} />;
    }
);
